module.exports = __webpack_public_path__ + "static/media/background_2.bd534ba4.jpg";